// @ts-strict-ignore
import { Component, Input } from '@angular/core';
import { TableColumn, TableData, TableParentColumn, TableRow } from '../../types';

@Component({
    selector: 'app-body-row',
    templateUrl: './body-row.component.html',
    standalone: false
})
export class BodyRowComponent {
  @Input() child: boolean;
  @Input() column: TableColumn | TableParentColumn;
  @Input() data: TableData = { rows: [], columns: [] };
  @Input() disabled: boolean = false;
  @Input() ignoreReadOnly: boolean = false;
  @Input() row: TableRow;
  @Input() parent: TableRow;

  trackByColumnId(i, column: TableColumn): string {
    return column.id;
  }
}
